export default __webpack_public_path__ + "media/images/images/flags/ut-27b4845541335fe44a87dcdbcc355960.png";